import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription, of } from 'rxjs';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';
import { CommonService } from 'src/app/shared/utils/common.service';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { Utility } from 'src/app/shared/utils/utility.service';
import { IUser } from 'src/app/user-management/user-management-interfaces';
import { UserManagementService } from 'src/app/user-management/user-management.service';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { FloorManagementService } from 'src/app/floor-management/floor-management.service';
import { IDevice } from 'src/app/building-managment/building-unit-details/add-lock/lock-management-interfaces';
import { BuildingManagementService } from 'src/app/building-managment/building-management.service';

@Component({
  selector: 'app-dashboard-active-issues-detail',
  templateUrl: './dashboard-active-issues-detail.component.html',
  styleUrls: ['./dashboard-active-issues-detail.component.scss'],
})
export class DashboardActiveIssuesDetailComponent implements OnInit, OnDestroy {
  CONSTANTS = CONSTANTS;
  subscription: Subscription | undefined;
  apiSubscription: Subscription | undefined;
  user: IUser | null | undefined;
  sharedDataSubscription?: Subscription;

  activeTab: string = '';
  readonly LANG_CONST = LANG_CONST;
  siteId!: string;
  id!: string;
  buildingId!: string;
  unitId!: string;
  buildingName!: string;
  previousId!: string;
  sharedData?: ISharedData;
  userGroups!: string;
  accessPointCount: number = 0;
  devicesCount: number = 0;
  accessPointCounts!: number;
  lockCount!: number;
  disabledLockTab = false;
  disabledUserTab = false;
  noAccessAvailable: boolean = false;
  floorId!: string;
  unitName: any;
  deviceCount: any;
  floorName: any;
  wingName: any;
  deviceList!: IDevice[] | undefined;
  usersList!: Observable<IUser[] | undefined>;

  tempHoldBuildingName!: string;

  constructor(
    private route: ActivatedRoute,
    private userManagementService: UserManagementService,
    private helperService: HelperService,
    private notificationService: NotificationService,
    private sharedDataService: SharedDataService,
    private router: Router,
    private commonService: CommonService,
    private floorManagementService: FloorManagementService,
    private buildingManagementService: BuildingManagementService
  ) {}

  ngOnInit(): void {
    this.subscription = this.route.params.subscribe((params) => {
      this.id = Utility.decodeFromBase64(params['id']);
      this.buildingId = Utility.decodeFromBase64(params['buildingId']);
      this.unitId = Utility.decodeFromBase64(params['unitId']);
      this.floorId = Utility.decodeFromBase64(params['floorId']);
      this.tempHoldBuildingName = Utility.decodeFromBase64(
        params['buildingName']
      );
      this.sharedDataSubscription =
        this.sharedDataService.currentData.subscribe((sharedData) => {
          this.sharedData = sharedData;
          const newSiteId = String(this.sharedData?.selectedSite?.siteId);

          if (this.siteId && this.siteId !== newSiteId) {
            this.router.navigate(['/dashboard/active-issues']);
            return;
          }

          if (this.id && this.previousId !== this.id) {
            this.previousId = this.id;
            this.siteId = newSiteId;
            this.getUnitDetail(
              this.siteId,
              this.buildingId,
              this.floorId,
              this.unitId
            );
            this.getLocksByUnitId(this.unitId);
            this.getUsersByUnitId(this.unitId);
          }
        });
    });
  }

  /**
   *
   * @param siteId {string}
   * @param buildingId {string}
   * @param floorId {string}
   * @param unitId {string}
   * @returns {unitName, deviceCount, floorName, wingName}
   */
  public getUnitDetail(
    siteId: string,
    buildingId: string,
    floorId: string,
    unitId: string
  ): void {
    this.floorManagementService
      .getUnit(siteId, buildingId, floorId, unitId)
      .subscribe({
        next: (res: any) => {
          this.unitName = res?.unitName;
          this.deviceCount = res?.deviceCount;
          this.floorName = res?.floorName;
          this.wingName = res?.wingName;
          this.buildingName = res?.buildingName;
        },
        error: (err: Error) => {
          if (window.__dev__) console.log('Get Unit detail', err);
        },
      });
  }

  /**
   * @param unitId {string}
   * @returns will return all device data
   */
  private getLocksByUnitId(unitId: string): void {
    this.floorManagementService.getDeviceByUnitId(unitId, false).subscribe({
      next: (deviceData: any) => {
        this.deviceList = deviceData as IDevice[];
        if (this.deviceList?.length > 0) {
          this.disabledLockTab = false;
          this.activeTab = CONSTANTS.LOCKTAB;
        } else {
          this.disabledLockTab = true;
        }
      },
      error: (err: Error) => {
        this.disabledTabs();
        if (window.__dev__) console.log('Get locks: ', err);
      },
    });
  }

  /**
   * @param unitId {string}
   * @returns will return all user- by unit id
   */
  private getUsersByUnitId(unitId: string): void {
    this.buildingManagementService.getUserViaUnit(unitId, false).subscribe({
      next: (userData: any) => {
        if (userData?.length > 0) {
          this.usersList = of(userData);
          this.disabledUserTab = false;
        } else {
          this.disabledUserTab = true;
        }
      },
      error: (err: Error) => {
        this.disabledTabs();
        if (window.__dev__) console.log('Get users: ', err);
      },
    });
  }

  disabledTabs(): void {
    this.buildingName = '';
    this.activeTab = CONSTANTS.LOCKTAB;
    this.disabledUserTab = true;
    this.disabledLockTab = true;
  }

  /**
   * @description  Remove selected unit
   * @returns void
   */
  removeUnit(): void {}

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.apiSubscription?.unsubscribe();
    this.sharedDataSubscription?.unsubscribe();
  }
}
